<template>
  <v-container id="dashboard" tag="section" class="px-10 pb-10">
    <div class="row">
      <div class="column">
        <canvas id="statisticPatient"></canvas>
        <canvas id="statisticMoney"></canvas>
      </div>
      <div class="column">
        <div>
          <canvas id="statisticPrescription"></canvas>
        </div>
        <div>
          <canvas id="statisticMedicine"></canvas>
        </div>
      </div>
    </div>
  </v-container>
</template>

<script>
import { mapState } from "vuex";
import Chart from "chart.js/auto";
export default {
  data() {
    return {};
  },
  methods: {
    async statisticPatient() {
      const patient = document.getElementById("statisticPatient");
      new Chart(patient, {
        type: "bar",
        responsive: true,
        data: {
          labels: [
            "Tháng 1",
            "Tháng 2",
            "Tháng 3",
            "Tháng 4",
            "Tháng 5",
            "Tháng 7",
            "Tháng 8",
            "Tháng 9",
            "Tháng 10",
            "Tháng 11",
            "Tháng 12",
          ],
          datasets: [
            {
              label: "Đơn vị tính (người)",
              data: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12],
              backgroundColor: ["rgb(255, 125, 125)"],
              borderColor: ["rgb(255, 125, 125)"],
              borderWidth: 1,
            },
          ],
        },
        options: {
          scales: {
            y: {
              beginAtZero: true,
            },
          },
          plugins: {
            legend: {
              position: "top",
            },
            title: {
              display: true,
              text: "Bệnh nhân",
              align: "start",
            },
          },
        },
      });
    },
    async statisticMoney() {
      const patient = document.getElementById("statisticMoney");
      new Chart(patient, {
        type: "line",
        responsive: true,
        data: {
          labels: [
            "Tháng 1",
            "Tháng 2",
            "Tháng 3",
            "Tháng 4",
            "Tháng 5",
            "Tháng 7",
            "Tháng 8",
            "Tháng 9",
            "Tháng 10",
            "Tháng 11",
            "Tháng 12",
          ],
          datasets: [
            {
              label: "Đơn vị tính (người)",
              data: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12],
              backgroundColor: ["rgb(110, 204, 175)"],
              borderColor: ["rgb(110, 204, 175)"],
              borderWidth: 1,
            },
          ],
        },
        options: {
          scales: {
            y: {
              beginAtZero: true,
            },
          },
          plugins: {
            legend: {
              position: "top",
            },
            title: {
              display: true,
              text: "Doanh thu",
              align: "start",
            },
          },
        },
      });
    },
    async statisticPrescription() {
      const patient = document.getElementById("statisticPrescription");
      new Chart(patient, {
        type: "line",
        responsive: true,
        data: {
          labels: [
            "Tháng 1",
            "Tháng 2",
            "Tháng 3",
            "Tháng 4",
            "Tháng 5",
            "Tháng 7",
            "Tháng 8",
            "Tháng 9",
            "Tháng 10",
            "Tháng 11",
            "Tháng 12",
          ],
          datasets: [
            {
              label: "Đơn vị tính (số đơn) / bác sỹ",
              data: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12],
              backgroundColor: ["rgb(170, 203, 115)"],
              borderColor: ["rgb(170, 203, 115)"],
              borderWidth: 1,
            },
          ],
        },
        options: {
          scales: {
            y: {
              beginAtZero: true,
            },
          },
          plugins: {
            legend: {
              position: "top",
            },
            title: {
              display: true,
              text: "Đơn kê",
              align: "start",
            },
          },
        },
      });
    },
    async statisticMedicine() {
      const patient = document.getElementById("statisticMedicine");
      new Chart(patient, {
        type: "bar",
        responsive: true,
        data: {
          labels: [
            "Tháng 1",
            "Tháng 2",
            "Tháng 3",
            "Tháng 4",
            "Tháng 5",
            "Tháng 7",
            "Tháng 8",
            "Tháng 9",
            "Tháng 10",
            "Tháng 11",
            "Tháng 12",
          ],
          datasets: [
            {
              label: "Đơn vị tính (số đơn) / bác sỹ",
              data: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12],
              backgroundColor: ["rgb(251, 176, 64)"],
              borderColor: ["rgb(251, 176, 64)"],
              borderWidth: 1,
            },
          ],
        },
        options: {
          scales: {
            y: {
              beginAtZero: true,
            },
          },
          plugins: {
            legend: {
              position: "top",
            },
            title: {
              display: true,
              text: "Vị thuốc",
              align: "start",
            },
          },
        },
      });
    },
  },
  async mounted() {
    this.statisticPatient();
    this.statisticMoney();
    this.statisticPrescription();
    this.statisticMedicine();
  },
};
</script>
<style scoped>
.row:after {
  content: "";
  display: table;
  clear: both;
}
/* Create four equal columns that floats next to each other */
.column {
  float: left;
  width: 50%;
  padding: 10px;
  height: 300px; /* Should be removed. Only for demonstration */
}
</style>
